
import httpClient from "../Core/http";

class ServiceReportsAPi {
  getCustomerServiceReports(params: any, signal: any): Promise<any> {
    let url = "serviceReports/customer";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
  getMachineServiceReports(params: any, signal: any): Promise<any> {
    let url = "serviceReports/machine";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
}

export const ServiceReportsApi = new ServiceReportsAPi();
